import { QueryBuilderTokenType } from '../../../../../../types';

export const applyConditionValueSwap = (
  tokens: QueryBuilderTokenType[],
  tokenIndex: number,
  value: string
): QueryBuilderTokenType[] | null => {
  const token = tokens[tokenIndex];

  if (token?.type !== 'entity') {
    return null;
  }

  const nextTokens = [...tokens];
  nextTokens[tokenIndex] = {
    type: 'entityValue',
    entityKey: token.entityKey,
    value,
  };

  return nextTokens;
};
